export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            最新影视预告片速览，提前锁定值得期待的好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <article className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300">
            <div className="relative w-full aspect-video overflow-hidden bg-background-200">
              <img src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20trailer%20thumbnail%20with%20dramatic%20action%20scene%2C%20warm%20golden%20lighting%2C%20hero%20character%20in%20dynamic%20pose%2C%20film%20grain%20texture%2C%20movie%20poster%20aesthetic%2C%20clean%20design&width=640&height=360&seq=media-trailer-01&orientation=landscape" alt="被窝网电影 - 《星际之门》预告片" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-2xl md:text-3xl ml-0.5 text-primary-600 group-hover:text-background-50"></i>
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/60 text-background-50 rounded whitespace-nowrap">
                02:35
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">《星际之门》正式预告</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">暑期档最受期待科幻大片，视效炸裂引爆期待</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 128万次</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i> 3天前</span>
              </div>
            </div>
          </article>

          <article className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300">
            <div className="relative w-full aspect-video overflow-hidden bg-background-200">
              <img src="https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20trailer%20thumbnail%20with%20warm%20sunset%20lighting%2C%20couple%20embracing%20in%20golden%20field%2C%20soft%20cinematic%20glow%2C%20emotional%20mood%2C%20film%20poster%20aesthetic%2C%20clean%20composition&width=640&height=360&seq=media-trailer-02&orientation=landscape" alt="被窝网电影 - 《晚风知我意》预告片" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-2xl md:text-3xl ml-0.5 text-primary-600 group-hover:text-background-50"></i>
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/60 text-background-50 rounded whitespace-nowrap">
                01:48
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">《晚风知我意》先导预告</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">治愈系爱情片，唯美画面温暖人心，秋天上映</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 96万次</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i> 5天前</span>
              </div>
            </div>
          </article>

          <article className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300">
            <div className="relative w-full aspect-video overflow-hidden bg-background-200">
              <img src="https://readdy.ai/api/search-image?query=Anime%20movie%20trailer%20thumbnail%20with%20vibrant%20animation%20style%2C%20colorful%20fantasy%20world%2C%20dynamic%20character%20design%2C%20warm%20magical%20atmosphere%2C%20Japanese%20animation%20aesthetic%2C%20clean%20composition&width=640&height=360&seq=media-trailer-03&orientation=landscape" alt="被窝网电影 - 《梦境奇缘》预告片" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-2xl md:text-3xl ml-0.5 text-primary-600 group-hover:text-background-50"></i>
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/60 text-background-50 rounded whitespace-nowrap">
                03:12
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">《梦境奇缘》剧场版PV</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">人气动漫剧场版首曝PV，全新冒险即将启程</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 215万次</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i> 1天前</span>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}